import { atom } from 'recoil';

import type { ChipPreviewData } from '../TimelineViewPragmatic/SortedToPlanChipPragmatic/DraggableTimelineCardPragmatic.utils';

const composeAtomKey = (name: string) => `TimelineView_${name}`;

export const appointmentDropPositionXAtom = atom<Record<string, number> | null>(
  {
    key: composeAtomKey('appointmentDropPositionX'),
    default: null
  }
);

/**
 * Holds the "frozen" drag frame after a drop: a copy of the dropped card is
 * held at the cursor and the matching dropzone keeps its highlight until the
 * API call + refetch settle. Presentation only — no source-of-truth change.
 */
export interface FrozenDrop {
  /** Ids of the dragged event(s) so their source chips stay faded (no snap-back). */
  eventIds: string[];
  /** Cursor / drop point in viewport coordinates. */
  position: { x: number; y: number };
  /** Number of dragged cards (>1 renders the multi-select preview). */
  count: number;
  /** Provider-free data to render the chip preview. */
  preview: ChipPreviewData;
}

export const frozenDropAtom = atom<FrozenDrop | null>({
  key: composeAtomKey('frozenDrop'),
  default: null
});

export const recurringTooltipIdAtom = atom<string>({
  key: composeAtomKey('recurringTooltipId'),
  default: ''
});
